import { FC, PropsWithChildren, ReactNode } from 'react';
import { FlexCol, FlexRow } from '../ui/flex';
import { Text } from '../ui/text';

type PageHeaderProps = {
  title: string;
  subtitle: string;
  badge?: ReactNode;
};

export const PageHeader: FC<PropsWithChildren<PageHeaderProps>> = ({
  title,
  subtitle,
  badge,
  children,
}) => {
  return (
    <FlexRow gap="4">
      <div className="p-5 bg-ditto-200 rounded-2xl">{children}</div>
      <FlexCol>
        <FlexRow alignItems="center" gap="3">
          <Text variant="header1" color="primary">
            {title}
          </Text>
          {badge}
        </FlexRow>
        {!!subtitle && (
          <Text variant="body" color="secondary">
            {subtitle}
          </Text>
        )}
      </FlexCol>
    </FlexRow>
  );
};
